// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"App_wrapper__2Rh_f","main":"App_main__3ZkGI","loginRegBg":"App_loginRegBg__gwJyy"};